import React from "react";
import { Outlet } from "react-router-dom";

// Ctx
import { SofiaMagicStudioProvider } from "contexts/sofia-magic-studio-ctx";

import ModalBetaConfirm from "components/molecules/sofia-magic-studio/modal-beta-confirm";

const SofiaMagicStudio = () => {
  return <Outlet />;
};

const Wrapper = () => {
  const [isOpen, setIsOpen] = React.useState(
    localStorage.getItem("sofia-magic-studio-beta-confirm") !== "true",
  );

  return (
    <SofiaMagicStudioProvider>
      <SofiaMagicStudio />
      <ModalBetaConfirm
        isOpen={isOpen}
        onConfirm={() => setIsOpen(false)}
      />
    </SofiaMagicStudioProvider>
  );
};

export default Wrapper;
